import styled from '@emotion/styled'

const L2RootLayout = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
}))

export default L2RootLayout
